import React from 'react';
import { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Empty from './Paneles/Empty';

import SigePedidos from './Paneles/SigePedidos';
import Consultador from './Paneles/Consultador';
import Articulos from './Paneles/Articulos';
import Generales from './Paneles/Generales';
import Configuracion from './Paneles/Configuracion';

import './styles.scss';

const Ayuda = () => {
  const [currentItemSelected, setCurrentItemSelected] = useState(0);
  const onClick = (index) => (() => setCurrentItemSelected(index));
  return (
    <Container className="w-100 h-100" fluid>
      <header>
        <h1 className="text-center">Bienvenido al Centro de Ayuda del E-SIGE</h1>
        {
          currentItemSelected > 0 &&
          <h5>
            Aquí podras encontrar información útil acerca de las funcionalidades que ofrece el panel de gestión E-SIGE.
            No obstante, se recuerda que ante inconvenientes no cubiertos por la presente documentación,
            se recomienda cargar un ticket detallado en nuestro <a className="text-dark font-weight-bold" target="_blank" href="https://accesoclientes.paradigma.com.ar">Sistema de Tickets</a>.
          </h5>
        }
      </header>
      <Row>
        <Col xs={3}>
          <Row>
            <Col xs={12} className="d-flex flex-column align-items-center border rounded btn btn-secondary m-1" onClick={onClick(1)}>
              <i class="fa fa-mobile fa-3x" aria-hidden="true"></i>
              SIGE Pedidos
            </Col>
            <Col xs={12} className="d-flex flex-column align-items-center border rounded btn btn-secondary m-1" onClick={onClick(2)}>
              <i class="fa fa-desktop fa-3x" aria-hidden="true"></i>
              Consultador
            </Col>
            <Col xs={12} className="d-flex flex-column align-items-center border rounded btn btn-secondary m-1" onClick={onClick(3)}>
              <i class="fa fa-cart-arrow-down fa-3x" aria-hidden="true"></i>
              Artículos
            </Col>
            <Col xs={12} className="d-flex flex-column align-items-center border rounded btn btn-secondary m-1" onClick={onClick(4)}>
              <i class="fa fa-cog fa-3x" aria-hidden="true"></i>
              Configuración
            </Col>
            <Col xs={12} className="d-flex flex-column align-items-center border rounded btn btn-secondary m-1" onClick={onClick(5)}>
              <i class="fa fa-list fa-3x" aria-hidden="true"></i>
              Generales
            </Col>
          </Row>
        </Col>
        <Col>
          {currentItemSelected == 0 && <Empty />}
          {currentItemSelected == 1 && <SigePedidos />}
          {currentItemSelected == 2 && <Consultador />}
          {currentItemSelected == 3 && <Articulos />}
          {currentItemSelected == 4 && <Configuracion />}
          {currentItemSelected == 5 && <Generales />}
        </Col>
      </Row>
    </Container>
  )
}

export default Ayuda;


// WEBPACK FOOTER //
// ./src/views/Ayuda/Ayuda.js